/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-11-09 11:56:20
 */
import React, { useState } from 'react'
import { Button, Divider, Layout } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'
import FileSaver from 'file-saver'
import styles from './index.module.scss'
import Upload from './Upload'
import Preview from './Preview'
import excel_icon from '../../../images/excel_icon.jpeg'
import CONFIG from '../../../constants/config'
import sensors from '../../../utils/sensors'

import PageHeader from '@/components/PageHeader'

const { Content } = Layout

// 成员数据类型
interface MemberData {
  userName: string
  userMobile: string
  department: string
}

// 失败数据类型
interface FailedDataItem {
  userName: string
  userMobile: string
  department: string
  mobileStatus: number
}

const OrgArcBatchImport: React.FC = () => {
  const [isVisibleResults, setIsVisibleResults] = useState(false)
  const [members, setMembers] = useState<MemberData[]>([])
  const [failedData, setFailedData] = useState<FailedDataItem[]>([])

  return (
    <Layout className="BunchImport">
      <PageHeader
        className="Header"
        ghost={true}
        title="导入成员"
        subTitle={'为确保导入成功，请严格按照模板里的格式填写用户信息！'}
      />

      <Content className="content">
        <div className={styles['batch-import-container']}>
          <div className={styles['operate-wrapper']}>
            <div className={styles.step1}>
              <div className={styles.title}>1.下载模板，填写客户信息</div>
              <img src={excel_icon} className={styles['excel-icon']} alt="" />
              <div>《组织架构成员模板》</div>
              <Button
                icon={<DownloadOutlined />}
                className={styles['download-template']}
                onClick={() => {
                  sensors.track(
                    'web_workgroup_membermanagement_addmember_Excel_download',
                    {
                      from: 'organization'
                    }
                  )

                  FileSaver.saveAs(
                    CONFIG.orgStructureExcelUrl,
                    '组织架构成员模板（有问题联系客服）.xlsx'
                  )
                }}
              >
                立即下载
              </Button>
            </div>
            <div className={styles.step2}>
              <div className={styles.title}>2.上传填写完毕的Excel文件</div>
              <Upload
                setIsVisibleResults={setIsVisibleResults}
                updateCallback={(newMembers, newFailedData) => {
                  setMembers(newMembers)
                  setFailedData(newFailedData)
                }}
              />
            </div>
          </div>

          {isVisibleResults && (
            <>
              <Divider style={{ marginTop: 36 }} />
              <Preview total={members.length} failedData={failedData} />
            </>
          )}
        </div>
      </Content>
    </Layout>
  )
}

export default OrgArcBatchImport
